import { gql } from "@grandvisionhq/graphql";
const OptInsFragment = gql`
  fragment OptInsFragment on OptIn {
    id
    literalText
    uiType
    value
    __typename
  }
`;
export {
  OptInsFragment as default
};
//# sourceMappingURL=opt-ins-fragment.js.map
